<template>
  <v-layout row wrap class="mt-1">
    <v-flex xs12 md8>
      <div class="class-box elevation-2 mb-3" style="position: relative;">          
        <v-layout row wrap>
          <v-flex xs3><strong>TURMA</strong></v-flex>
          <v-flex xs3><strong>UNIDADE</strong></v-flex>
          <v-flex xs3><strong>INICIO</strong></v-flex>
          <v-flex xs3><strong>TERMINO</strong></v-flex>
        </v-layout>
      </div>
      <class-card v-for="classItem in classes" :key="classItem.id" class="mb-3" :class-data="classItem"/>
    </v-flex>
    <v-flex xs12 md4>
      <v-form ref="classForm" class="elevation-2" v-model="classFormValid" lazy-validation>
        <v-layout row wrap class="px-3">
          <v-flex xs12>
            <h3 class="mb-2">NOVA TURMA</h3>
            <hr>
          </v-flex>
          <v-flex xs12>
            <v-select box color="black" v-model="classData.unit" @change="clear()" hint="UNIDADE. Ex: São Paulo." :items="units" item-text="name" item-value="id" label="UNIDADE" persistent-hint return-object single-line required></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select box color="black" v-model="classData.course" @change="getGrids()" hint="CURSO. Ex: Computação Forense." :items="courses" item-text="name" item-value="id" label="CURSOS" :disabled="classData.unit.id == ''" persistent-hint return-object single-line required></v-select>
          </v-flex>
          <v-flex xs12>
            <v-select box color="black" v-model="classData.grid" @change="getCode()" hint="GRADE. Ex: V2019, V2020." :items="grids" item-text="name" item-value="id" label="GRADES" :disabled="classData.course.id == ''" persistent-hint return-object single-line required></v-select>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="classData.code" :counter="3" label="CÓDIGO, EX: 006, 016" :disabled="true" required box/>
          </v-flex>
          <v-flex xs12 class="pt-0">
            <v-btn style="width: 100%;" class="ma-0" :disabled="!classData.code" @click="createClass()" outline>CADASTRAR</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
    <div class="loadMoreAction">
      <v-btn color="white" @click="getMore()" outline>CARREGAR MAIS TURMAS</v-btn>
    </div>
  </v-layout>
</template>

<script>
import classCard from '../../components/ClassCard'

export default {
  name: 'classes',
  components: { classCard },
  data() {
    return {
      classFormValid: true,
      classData: {
        unit: { name: '', id: '' },
        course: { name: '', id: '' },
        grid: { name: '', id: '' },
        code: ''
      },
      units: [],
      courses: [],
      grids: [],
      classes: [],
      controlQtd: {
        skip: 0,
        limit: 100
      }
    }
  },
  methods: {
    getUnits() {
      this.classData.code = ''
      this.$http.get('units').then(data => {
        this.units = data.data
      }).catch(err => {

      })
    },
    getCourses() {
      this.classData.code = ''
      this.$http.get('courses').then(data => {
        this.courses = data.data
      }).catch(err => {

      })
    },
    getGrids() {
      this.grids = []
      this.classData.code = ''
      this.classData.grid = { name: '', id: '' }
      this.$http.get(`grids/closed/${this.classData.course.id}`).then(data => {
        this.grids = data.data
      }).catch(err => {

      })
    },
    getCode() {
      this.classData.code = ''
      this.$http.get(`classes/code/${this.classData.course.id}/${this.classData.unit.id}`).then(data => {
        this.classData.code = data.data.count
      }).catch(err => {

      })
    },
    clear() {
      this.classData.code = ''
      this.classData.course = { name: '', id: '' }
      this.classData.grid = { name: '', id: '' }
    },
    createClass() {
      this.$http.get(`grids/modules/quantity/${this.classData.grid.id}`).then(data => {
        const gridModules = data.data.quantity
        this.$http.post(`classes`, {
          code: this.classData.code,
          course: this.classData.course.id,
          unit: this.classData.unit.id,
          grid: this.classData.grid.id,
          modulesGen: gridModules,
          type: this.classData.course.type
        }).then(data => {
          this.$router.push({name: 'classPos', params: {id: data.data.insertedClass.insertId}})
        }).catch(err => {

        })
      }).catch(err => {

      })
    },
    getClasses() {
      this.$http.get(`classes/all/page/${this.controlQtd.skip}/${this.controlQtd.limit}`).then(data => {
        // this.classes = this.classes.concat(data.data)
        this.classes = (data.data.reverse()).concat(this.classes)
      }).catch(err => {

      })
    },
    getMore() {
      this.controlQtd.skip += 100
      this.getClasses()
    },
  },
  created() {
    this.getUnits()
    this.getCourses()
    this.getClasses()
  }
}
</script>

<style scoped>
  .loadMoreAction {
    position: fixed;
    top: 0;
    right: 16px;
    z-index: 6;
  }
  .class-box {
    border-left: solid 10px #c4161c;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background-color: #fff;
    padding-left: 20px;
    margin-bottom: 26px;
    cursor: pointer;
  }
</style>
